export const PostboxMinLength = 2;
export const PostboxMaxLength = 150;
export const PostboxDebounceTime = 300;
export const RequestLimit = 200;
export const PostboxControlName = 'Postbox';
export const PostboxLabel = 'Поштомат';
export const PostboxPlaceholder = '';
export const PostboxClasses = 'form-col w-70';
